export const ERROR_GET_ERRORS = 'ERROR_GET_ERRORS';
export const ERROR_CLEAR_ERRORS = 'ERROR_CLEAR_ERRORS';